<template>
  <v-dialog v-model="dialog" scrollable persistent width="800px">
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <span class="text-center headline"> Seleccionar Sedes </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-combobox
            v-model="unidad"
            :items="unidades"
            class="mb-4"
            hide-selected
            hide-details
            label="Filtrar por Unidad:"
            item-text="nombre"
            outlined
            color="green"
            persistent-hint
            dense
          >
          </v-combobox>

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="sedes"
            :single-select="singleSelect"
            :loading="loading_sedes"
            disable-pagination
            hide-default-footer
            item-key="id"
            show-select
            class="elevation-1"
          >
          </v-data-table>
        </v-container>

        <p class="text-center red--text">{{ msg }}</p>
        <v-progress-linear indeterminate v-if="loading" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded outlined @click="enviarSeleccionados()">
          <v-icon class="mx-1">mdi-content-save</v-icon> Aceptar
        </v-btn>
        <v-btn rounded outlined @click="cleartipo()"> <v-icon>mdi-close</v-icon> Cancelar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import gql from 'graphql-tag';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        loading_sedes: false,
        allsedes: [],
        sedes: [],
        unidades: [],
        unidad: null,
        msg: '',
        singleSelect: false,
        selected: [],
        headers: [{ text: 'Sede', value: 'nombre' }],
      };
    },
    computed: {},
    watch: {
      unidad: function() {
        this.sedes = this.allsedes.filter((x) => x.negocio.id == this.unidad.id);
      },
    },
    methods: {
      openmodal() {
        this.dialog = true;
        this.selected = [];
        this.sedes = [];
        this.getSedes();
      },
      cleartipo() {
        this.$emit('cleartipo');
        this.dialog = false;
      },
      getSedes() {
        this.loading_sedes = true;
        const qs = gql` query {getSedes ${''} {id, nombre,unidad_negocio,negocio{id,nombre}, ciudad{ id, nombre, departamento {nombre}}}}`;
        this.$apollo
          .query({ query: qs })
          .then(({ data: { getSedes } }) => {
            let datos = getSedes.length ? getSedes : [];
            let units = [];
            datos.forEach((x) => {
              let exunit = units.find((u) => u.id == x.negocio.id);
              if (!exunit) units.push(x.negocio);
            });
            this.unidades = units;
            this.allsedes = datos.filter((x) => x.id > -1);
            //this.sedes = datos;
            this.unidad = units[0];
            this.loading_sedes = false;
          })
          .catch(() => []);
      },
      enviarSeleccionados() {
        this.$emit('sedes_sel', this.selected);
        this.dialog = false;
      },
    },
  };
</script>
